
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAll_Sort_Report = createAsyncThunk(
    'report/fetchAll_Sort_report',
    async ( {startDate , endDate , departmentpayload} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/sort?StartDate=${startDate}&EndDate=${endDate}&Department=${departmentpayload}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all sort Report');
        }
    }
);
export const fetchAll_Sort_Employee = createAsyncThunk(
    'report/fetchAll_Sort_Employee',
    async ( {startDate , endDate , EmployeeID} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/sort/employeecard?StartDate=${startDate}&EndDate=${endDate}&EmployeeID=${EmployeeID}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all sort Report');
        }
    }
);
export const fetchAll_Sort_count = createAsyncThunk(
    'report/fetchAll_Sort_count',
    async ( {startDate , endDate , departmentpayload} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/sort/count?StartDate=${startDate}&EndDate=${endDate}&Department=${departmentpayload}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Sort Report');
        }
    }
);
export const fetchAll_Sort_count_monthly = createAsyncThunk(
    'report/fetchAll_Sort_count_monthly',
    async ( {startDate , endDate , departmentpayload} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/sort/count/monthly?StartDate=${startDate}&EndDate=${endDate}&Department=${departmentpayload}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Sort Report');
        }
    }
);